import { useMutateEntry } from '@utils/component-framework';
import { bringItemToFront } from './utils/bring-item-to-front.js';
import { getItemEntryById } from './utils/get-item-by-id.js';
import { getPageEntryById } from './utils/get-page-by-id.js';

function useCreateLineEntryMutation(entryKey) {
  const mutater = useMutateEntry(entryKey);
  return args => mutater(entry => {
    const {
      pageId,
      lineId,
      ...line
    } = args;
    const page = getPageEntryById(entry.data, pageId);
    const item = getItemEntryById(page, pageId);

    // push the new line to the configuration
    page.lines.push({
      ...line,
      kind: "line",
      id: lineId,
      settings: {
        movable: true,
        cloneable: false
      }
    });

    // bring the item to the front of the dynamically positioned items as it
    // was just inserted on top of them
    item.position = args.position;
    bringItemToFront(page, item);
    return entry;
  });
}

export { useCreateLineEntryMutation };
//# sourceMappingURL=line.create.js.map
